"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AclLogo___StyledSvg",
  componentId: "sc-1t3hqrl-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function AclLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M324.34 310.924h-13.18s-12.342 0-12.342 12.76c0 14.466-10.199 31.051-32.321 31.051-19.79 0-31.476-10.702-33.003-34.81v.002c-13.255 11.34-23.716 21.928-32.911 30.952 9.966 26.133 32.312 39.586 65.914 39.586 29.34 0 71.023-15.736 71.023-66.353 0-9.358-5.095-13.188-13.18-13.188zm112.503 43.811h-8.503c-27.218 0-29.358-16.16-29.358-32.327V102.072c0-7.232-5.526-12.336-11.906-12.336h-15.312c-6.38 0-11.484 5.104-11.484 12.336v220.336c0 42.11 22.122 68.057 68.06 68.057h8.503c7.23 0 12.343-5.528 12.343-11.909V366.22c0-6.38-5.113-11.485-12.343-11.485zm-203.535-99.169v.061-17.521c0-17.865 13.189-30.202 30.626-30.202 19.57 0 28.503 9.783 28.503 22.123 0 7.654 5.104 12.33 11.485 12.33h15.742c6.38 0 11.473-4.676 11.473-12.33 0-35.309-28.492-57.853-67.203-57.853-36.579 0-69.328 24.246-69.328 75.29v44.222c15.428-7.899 28.52-14.186 38.702-18.307v-17.813zm-99.937 58.763c0 19.563-15.32 40.406-37.434 40.406-16.17 0-27.217-13.61-27.217-27.223 0-7.657 2.963-19.994 19.982-23.815l44.67-10.638v21.27zm-30.626-142.498c-38.71 0-67.202 22.544-67.202 57.85 0 7.657 5.095 12.333 11.476 12.333h15.739c6.38 0 11.484-4.676 11.484-12.333 0-12.337 8.934-22.12 28.503-22.12 17.438 0 30.626 12.336 30.626 30.201v17.865L82.75 267.961C42.76 277.744 30 296.039 30 329.213c0 25.534 15.425 46.863 37.085 56.195.887.381 1.783.724 2.684 1.044 4.427.782 13.535 1 27.017-5.377 20.596-10.784 36.565-42.67 64.202-66.28l5.33-4.738c1.137-.928 3.577-2.815 5.755-4.496v-58.44c0-51.045-32.749-75.29-69.328-75.29z"
  }), _react["default"].createElement("path", {
    d: "M134.04 358.644c45.903-38.493 110.494-80.996 225.42-95.9 3.062-.398 8.484-1.15 8.484-1.15l-.304 10.649s-57.357 15.774-79.25 28.38c-81.91 47.156-81.58 88.985-119.152 88.985H91.043c-12.16 0-22.088-3.43-22.088-3.43s19.18 10.956 65.085-27.534z"
  })));
}

var _default = AclLogo;
exports["default"] = _default;